import { Button, Divider, Input, message, Select, Space, Spin } from "antd";
import styles from "./styles.module.scss";
import { DropdownSuffix, ExpandIcon, SearchIcon } from "icons";
import { useLanguageTranslator } from "hooks/use-language-translator";
import {
  childKeys,
  dropdownAddItemEndPoints,
  dropdownAddItemError,
} from "pages/cases-detail/constants";
import { useEffect, useRef, useState } from "react";
import { ConditionalRenderer } from "components";
import { PlusOutlined } from "@ant-design/icons";
import { PrefixInsideInput } from "../prefixInsideInput";
import { UseLazyApiCallV2 } from "hooks";

export const InputWithLabel = ({
  item,
  totalFormData,
  setTotalFormData,
  parentKey,
  autoFocus = false,
  parentItem,
}) => {
  const { refetchList } = item;

  const [
    addNewItemInDrodownDB,
    {
      data: addNewItemInDrodownDBData,
      isLoading: addNewItemInDrodownDBLoading,
      error: addNewItemInDrodownDBError,
    },
  ] = UseLazyApiCallV2({
    url: dropdownAddItemEndPoints[item?.dropdownType],
    method: "POST",
  });

  const { translator } = useLanguageTranslator();
  const inputRef = useRef(null);
  const [addItemIndropdown, setAddItemInDropdown] = useState();

  function handleSelect(e, data) {
    setTotalFormData((prev) => ({
      ...prev,
      [item.key]: data?.label,
      [`${item.key}_id`]: data?.value,
      [`${item.dependentDropdownKey}`]: "",
    }));
  }

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  function handleChangeInput(event) {
    const { name, value } = event.target;

    setTotalFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  // useEffect(() => {
  //   if (parentKey) {
  //     setTotalFormData((prev) => {
  //       const newValue = (childKeys?.[parentKey] || [])
  //         .map((childItem) => prev[childItem.key] || "")
  //         .filter(Boolean)
  //         .join(", ");

  //       return { ...prev, [parentKey]: newValue };
  //     });
  //   }
  // }, [
  //   ...childKeys[parentKey]?.map((childItem) => totalFormData[childItem.key]),
  // ]);
  useEffect(() => {
    if (!parentItem) return;

    setTotalFormData((prev) => {
      const combinedValue = parentItem.sections
        .map((section) =>
          section.childs
            .map((child) => prev[child.key] || "")
            .filter(Boolean)
            .join(", "),
        )
        .filter(Boolean)
        .join(" | ");

      return { ...prev, [parentItem.key]: combinedValue };
    });
  }, [
    parentItem, // re-run if parent changes
    ...parentItem.sections.flatMap((section) =>
      section.childs.map((child) => totalFormData[child.key]),
    ),
  ]);

  function onChangeAddItem(event) {
    const { value } = event.target;
    setAddItemInDropdown(value);
  }

  async function onClickAddDropdownItem({ name, value }) {
    if (!value)
      return message.error(
        translator(
          `caseDetail.form.${dropdownAddItemError[item?.dropdownType]}`,
        ),
      );
    const params = {
      [name]: value,
    };
    try {
      const res = await addNewItemInDrodownDB({ params });
      if (res?.status === "SUCCESS") {
        message.success(translator("addedSuccess"));
        refetchList();
        setAddItemInDropdown("");
      }
    } catch (error) {
      message.error(translator("somethingWentWrong"));
    }
  }

  return (
    <div
      className={styles.inputWithLabel}
      style={{
        width: "49%",
      }}
    >
      <Spin spinning={addNewItemInDrodownDBLoading}>
        <ConditionalRenderer
          condition={item?.type === "text" || item?.type === "number"}
        >
          <Input
            type="text"
            prefix={<PrefixInsideInput item={item} />}
            onChange={handleChangeInput}
            name={item.key}
            value={
              item?.dropdownType === "country"
                ? "Deutschland"
                : totalFormData[item.key]
            }
            ref={inputRef}
            style={{
              pointerEvents: item?.dropdownType === "country" ? "none" : "auto",
            }}
            maxLength={40}
          />
        </ConditionalRenderer>
        <ConditionalRenderer condition={item?.type === "dropdown"}>
          <div
            className={styles.dropdownWrapper}
            style={{
              position: "relative",
              border: autoFocus ? "1px solid #cd2a3f" : "1px solid #d9d9d9",
              borderRadius: "6px",
              display: "flex",
            }}
            ref={inputRef}
          >
            <PrefixInsideInput item={item} />
            <Select
              allowClear
              className={styles.select}
              showSearch
              filterOption={(
                input,
                option, // 👈 filter logic
              ) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              value={totalFormData[item.key]}
              style={{
                width: "100%",
                height: "40px",
              }}
              placeholder=""
              onChange={handleSelect}
              options={item?.dropdownList}
              suffixIcon={<DropdownSuffix />}
              dropdownRender={
                refetchList
                  ? (menu) => (
                      <>
                        {menu}
                        <Divider style={{ margin: "8px 0" }} />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Input
                            placeholder={translator("enterItem")}
                            // ref={inputRef}
                            name={item.dropdownType}
                            value={addItemIndropdown}
                            onChange={onChangeAddItem}
                            onKeyDown={(e) => e.stopPropagation()}
                            className={styles.addItemInput}
                            maxLength={40}
                          />
                          <Button
                            className={styles.addItemInputBtn}
                            type="text"
                            icon={<PlusOutlined />}
                            style={{ fontWeight: "bold" }}
                            onClick={() =>
                              onClickAddDropdownItem({
                                name: item?.dropdownType,
                                value: addItemIndropdown,
                              })
                            }
                          >
                            {translator("addItem")}
                          </Button>
                        </div>
                      </>
                    )
                  : undefined
              }
            />
          </div>
          {/* {item?.dropdownList?.map((item) => (
          <div>{item.companyName}</div>
        ))} */}
        </ConditionalRenderer>
      </Spin>
    </div>
  );
};
